var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCp1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.586,
    height: 68.65,
    viewBox: "0 0 41.586 68.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4474",
    "data-name": "Rectangle 4474",
    width: 41.586,
    height: 68.65,
    fill: "#3fa474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4473",
    "data-name": "Rectangle 4473",
    width: 41.585,
    height: 68.65,
    fill: "#3fa474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4471",
    "data-name": "Rectangle 4471",
    width: 0.592,
    height: 0.683,
    fill: "#3fa474"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4472",
    "data-name": "Rectangle 4472",
    width: 0.367,
    height: 0.237,
    fill: "#3fa474"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1689",
    "data-name": "Group 1689",
    transform: "translate(1.383 -0.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1688",
    "data-name": "Group 1688",
    transform: "translate(-1.383 0.718)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1687",
    "data-name": "Group 1687",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1682",
    "data-name": "Group 1682",
    transform: "translate(0.873 67.968)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1681",
    "data-name": "Group 1681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1680",
    "data-name": "Group 1680",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48522",
    "data-name": "Path 48522",
    d: "M1.792,93.507l-.592.166.406.516c.084-.31.119-.436.187-.683",
    transform: "translate(-1.2 -93.507)",
    fill: "#3fa474"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1685",
    "data-name": "Group 1685",
    transform: "translate(1.545 66.33)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1683",
    "data-name": "Group 1683",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48523",
    "data-name": "Path 48523",
    d: "M2.493,91.294l-.345-.04c-.008.057-.015.116-.023.173l.342.064c.008-.065.017-.132.025-.2",
    transform: "translate(-2.126 -91.254)",
    fill: "#3fa474"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48524",
    "data-name": "Path 48524",
    d: "M31.767,60.694a36.878,36.878,0,0,0-.1-4.355,2.834,2.834,0,0,0-3.059-2.6q-1.574,0-3.149,0a2.923,2.923,0,0,0-3.229,2.719c-.079.629-.313.67-.8.652-.786-.028-1.574-.018-2.361,0a2.834,2.834,0,0,0-3.011,2.821c-.033.528-.224.619-.683.6-.874-.03-1.75-.018-2.624,0A2.8,2.8,0,0,0,9.8,63.4c-.023.582-.01,1.166,0,1.749,0,.285.007.508-.4.482A18.156,18.156,0,0,1,3.5,64.678C.945,63.623.083,61.486.006,58.954a13.732,13.732,0,0,1,11.264-14c.8-.142,1.211-.158,1.513.76a6.883,6.883,0,0,0,1.831,2.416,57.541,57.541,0,0,0,5.715,5.006.6.6,0,0,0,.9.01,47.3,47.3,0,0,0,6.585-5.986,4.913,4.913,0,0,0,1.155-1.823c.137-.519.369-.568.8-.486,5.882,1.117,9.735,4.485,11.37,10.285a11.94,11.94,0,0,1,.275,5.275c-.447,2.65-2.3,4.359-5.325,4.843-1.2.192-2.433.228-3.646.367-.523.06-.709-.068-.689-.637.047-1.34.015-2.681.015-4.294",
    transform: "translate(0 -12.242)",
    fill: "#3fa474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48525",
    "data-name": "Path 48525",
    d: "M29.468,34.894c-3.758,2.953-7.4,2.866-10.671-.363a18.134,18.134,0,0,1-5.808-14.556,11.076,11.076,0,0,1,8.9-9.909,11.336,11.336,0,0,1,13.732,9.451c.523,3.091-.323,6.044-1.534,8.885a.684.684,0,0,1-.531.393,4.706,4.706,0,0,1-3.152.026,6.858,6.858,0,0,0-4.45-.036,2.948,2.948,0,0,0-2,3.44,3.146,3.146,0,0,0,2.995,2.662c.78.037,1.562.007,2.524.007",
    transform: "translate(-3.535 -2.68)",
    fill: "#3fa474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48526",
    "data-name": "Path 48526",
    d: "M34.563,22.24c0-1.021.011-2.041,0-3.061a2.7,2.7,0,0,1,1.219-2.46.677.677,0,0,0,.309-.8C35.225,8.8,30.223,3.532,23.152,2.717A14.638,14.638,0,0,0,6.857,16.081a.6.6,0,0,0,.333.624,2.753,2.753,0,0,1,1.23,2.457c-.012,1.837.017,3.674-.009,5.51a2.858,2.858,0,0,1-2.948,2.98A2.86,2.86,0,0,1,2.6,24.591c0-1.837.011-3.674-.005-5.51a2.608,2.608,0,0,1,1.089-2.254,1.238,1.238,0,0,0,.566-.989A16.836,16.836,0,0,1,8.4,5.993,16.822,16.822,0,0,1,22.2.013,17.308,17.308,0,0,1,38.616,14.649a8.663,8.663,0,0,1,.1,1.042,1.427,1.427,0,0,0,.672,1.21,2.494,2.494,0,0,1,1,2.122c-.012,1.866,0,3.731,0,5.6a2.858,2.858,0,0,1-4,2.8,1.039,1.039,0,0,0-1.087.132,15.558,15.558,0,0,1-6.7,2.223c-.219.028-.455-.072-.648.143-1.279,1.429-2.9.845-4.406.659-.749-.093-1.178-1.08-1-1.9a1.567,1.567,0,0,1,1.507-1.341c.871-.056,1.748-.02,2.623-.006a.763.763,0,0,1,.486.15c.778.769,1.678.557,2.586.367a14.55,14.55,0,0,0,4.377-1.609.847.847,0,0,0,.507-.943c-.087-1.012-.026-2.037-.026-3.056h-.045",
    transform: "translate(-0.707 0)",
    fill: "#3fa474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48527",
    "data-name": "Path 48527",
    d: "M33.643,68.614q0-3.63,0-7.26c0-1.038.107-1.137,1.156-1.138q1.356,0,2.712,0c1.025,0,1.182.156,1.194,1.216.009.816,0,1.633,0,2.449q0,5.905,0,11.809c0,1.252-.109,1.358-1.327,1.359-.875,0-1.752-.044-2.623.014-.842.056-1.138-.267-1.127-1.1.034-2.449.012-4.9.012-7.347",
    transform: "translate(-9.186 -16.447)",
    fill: "#3fa474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48528",
    "data-name": "Path 48528",
    d: "M30.171,71.563c0,1.895-.017,3.79.008,5.684.01.768-.243,1.115-1.068,1.066-1.017-.061-2.041-.041-3.06,0-.621.022-.933-.2-.933-.835q0-5.9,0-11.806c0-.593.279-.9.924-.876,1.048.033,2.1.043,3.147,0,.824-.036.984.419.982,1.09-.007,1.894,0,3.789,0,5.684",
    transform: "translate(-6.861 -17.695)",
    fill: "#3fa474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48529",
    "data-name": "Path 48529",
    d: "M21.632,74.544c0,1.369-.028,2.739.012,4.106.02.661-.16.965-.874.938-1.106-.042-2.214-.029-3.32,0-.625.015-.9-.216-.892-.863q.026-4.194,0-8.388c0-.651.294-.877.9-.868,1.107.017,2.214.015,3.32,0,.621-.009.88.23.862.885-.04,1.4-.012,2.8-.012,4.193",
    transform: "translate(-4.523 -18.973)",
    fill: "#3fa474"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp1);
export default __webpack_public_path__ + "static/media/cp1.24080175bbf0f357e107cba5e6f42ab2.svg";
export { ForwardRef as ReactComponent };